import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = { name: "Office M1", city: "Menen" };

export function useSiteInfo() {
    const [site, setSite] = useState(DEFAULT);
    useEffect(() => {
        api.get("/site")
            .then((r) => setSite(r.data))
            .catch(() => {});
    }, []);
    return site;
}
